// ══════════════════════════════════════════════════════════════════════════════
//  src/pages/PortalProfesorPage.jsx
//  La pagina del portal del profesor. Fina a proposito.
//
//  Lleva la cabecera de siempre —la misma que el gimnasio— porque el profesor
//  NO deja de ser usuario de la plataforma al entrar aqui: sigue teniendo su
//  tema, su menu y su salida. Esta pantalla se suma a lo que ya tiene, no lo
//  sustituye.
// ══════════════════════════════════════════════════════════════════════════════

import Header from '../components/Header.jsx';
import PortalProfesor from '../components/teacher/PortalProfesor.jsx';

export default function PortalProfesorPage() {
  return (
    <>
      <Header />
      <PortalProfesor />
    </>
  );
}
